/** FA sheet (skaters): column D = player name, column AD = contract status */
export const FA_SKATER_NAME_COLUMN = 3;
export const FA_SKATER_STATUS_COLUMN = 29;

/** FAG sheet (goalies): column C = goalie name, column W = contract status */
export const FA_GOALIE_NAME_COLUMN = 2;
export const FA_GOALIE_STATUS_COLUMN = 22;

export const FA_SKATER_CONFIG = {
  nameColumnIndex: FA_SKATER_NAME_COLUMN,
  statusColumnIndex: FA_SKATER_STATUS_COLUMN,
  skipNameHeaders: ['player name'],
};

export const FA_GOALIE_CONFIG = {
  nameColumnIndex: FA_GOALIE_NAME_COLUMN,
  statusColumnIndex: FA_GOALIE_STATUS_COLUMN,
  skipNameHeaders: ['goalie name'],
};

export function normalizePlayerName(name) {
  return String(name || '')
    .replace(/\u00a0/g, ' ')
    .replace(/\r/g, '')
    .trim()
    .toLowerCase();
}

export function parseFaStatusFromCell(value) {
  if (value === undefined || value === null || value === '') return null;

  const normalized = String(value)
    .replace(/\u00a0/g, ' ')
    .replace(/\r/g, '')
    .trim()
    .toLowerCase();

  if (!normalized) return null;
  if (normalized.includes('unrestricted')) return 'UFA';
  return 'RFA';
}

export function buildFaStatusMap(faRows, config = FA_SKATER_CONFIG) {
  const map = new Map();
  if (!Array.isArray(faRows)) return map;

  const { nameColumnIndex, statusColumnIndex, skipNameHeaders = [] } = config;

  for (const row of faRows) {
    if (!row) continue;

    const name = String(row[nameColumnIndex] ?? '').trim();
    if (!name) continue;

    const nameLower = name.toLowerCase();
    if (skipNameHeaders.some((header) => nameLower === header)) continue;

    const status = parseFaStatusFromCell(row[statusColumnIndex]);
    if (status) {
      map.set(normalizePlayerName(name), status);
    }
  }

  return map;
}

export function applyFaStatusToPlayer(player, faStatusMap) {
  if (!player || !faStatusMap?.size) return player;

  const faStatus = faStatusMap.get(normalizePlayerName(player.name));
  if (!faStatus) return player;

  return { ...player, faStatus };
}

export function applyFaStatusToPlayers(players, faStatusMap) {
  if (!Array.isArray(players)) return players;
  return players.map((player) => applyFaStatusToPlayer(player, faStatusMap));
}

export async function loadFaStatusMaps({
  loadGoogleSheetRows,
  loadExcelSheetRows,
  googleSheetId,
}) {
  const empty = { skaterMap: new Map(), goalieMap: new Map() };

  if (googleSheetId && loadGoogleSheetRows) {
    try {
      const faRows = await loadGoogleSheetRows(googleSheetId, 'FA');
      const skaterMap = buildFaStatusMap(faRows, FA_SKATER_CONFIG);

      let goalieMap = new Map();
      try {
        const fagRows = await loadGoogleSheetRows(googleSheetId, 'FAG');
        goalieMap = buildFaStatusMap(fagRows, FA_GOALIE_CONFIG);
      } catch {
        // FAG tab may be missing in older spreadsheets
      }

      if (skaterMap.size > 0 || goalieMap.size > 0) {
        return { skaterMap, goalieMap };
      }
    } catch {
      // Try Excel fallback below
    }
  }

  if (loadExcelSheetRows) {
    try {
      const faRows = await loadExcelSheetRows('FA');
      const skaterMap = buildFaStatusMap(faRows, FA_SKATER_CONFIG);

      let goalieMap = new Map();
      try {
        const fagRows = await loadExcelSheetRows('FAG');
        goalieMap = buildFaStatusMap(fagRows, FA_GOALIE_CONFIG);
      } catch {
        // FAG sheet optional in local db.xlsx
      }

      return { skaterMap, goalieMap };
    } catch {
      return empty;
    }
  }

  return empty;
}

/** @deprecated Use loadFaStatusMaps */
export async function loadFaStatusMap(options) {
  const { skaterMap } = await loadFaStatusMaps(options);
  return skaterMap;
}
